import React, { useState } from "react";
import "./style.css";
import { VscGrabber, VscClose } from "react-icons/vsc";
import { Link, NavLink, useLocation } from "react-router-dom";
import Typewriter from "typewriter-effect";
import { socialprofils, introdata } from "../content_option";

const nav = [
  { to: "/", label: "home", end: true },
  { to: "/about", label: "about" },
  { to: "/portfolio", label: "projects" },
  { to: "/contact", label: "contact" },
];

const Headermain = () => {
  const [isOpen, setOpen] = useState(false);
  const isHome = useLocation().pathname === "/";

  const toggle = () => {
    setOpen(!isOpen);
    document.body.classList.toggle("ovhidden");
  };
  const close = () => {
    setOpen(false);
    document.body.classList.remove("ovhidden");
  };

  return (
    <>
      <header className="fixed-top site__header">
        <div className="header__row">
          <div className="brand__group">
            <Link className="brand mono" to="/" onClick={close}>
              <span className="brand__prompt">drew@jordan</span>
              <span className="brand__sep">:</span>
              <span className="brand__path">~</span>
              <span className="brand__cursor">$</span>
            </Link>

            {/* typed roles on inner pages; home has its own hero */}
            {!isHome && (
              <span className="brand__typed mono" aria-hidden="true">
                <Typewriter
                  options={{
                    strings: [
                      introdata.animated.first,
                      introdata.animated.second,
                      introdata.animated.third,
                    ],
                    autoStart: true,
                    loop: true,
                    delay: 55,
                    deleteSpeed: 30,
                  }}
                />
              </span>
            )}
          </div>

          {/* desktop inline nav */}
          <nav className="nav__inline mono">
            {nav.map((item, i) => (
              <NavLink key={item.to} to={item.to} end={item.end} className="nav__link">
                <span className="nav__idx">{String(i + 1).padStart(2, "0")}</span>
                {item.label}
              </NavLink>
            ))}
            <a
              className="nav__link"
              href="/assets/Andrew_Jordan_Resume_2026.pdf"
              download
            >
              <span className="nav__idx">05</span>resume
            </a>
          </nav>

          <div className="header__actions">
            <a className="nav__ext mono" href={socialprofils.github} target="_blank" rel="noopener noreferrer">github</a>
            <a className="nav__ext mono" href={socialprofils.linkedin} target="_blank" rel="noopener noreferrer">linkedin</a>
            <button className="menu__button" onClick={toggle} aria-label="menu">
              {isOpen ? <VscClose /> : <VscGrabber />}
            </button>
          </div>
        </div>
      </header>

      {/* mobile overlay — sibling of <header>: the header's backdrop-filter
          establishes a containing block that would otherwise trap this fixed
          element inside the 64px header box */}
      <div className={`site__navigation ${isOpen ? "menu__opend" : ""}`}>
          <div className="bg__menu h-100">
            <div className="menu__wrapper">
              <div className="menu__container p-3">
                <ul className="the_menu mono">
                  {nav.map((item, i) => (
                    <li className="menu_item" key={item.to}>
                      <NavLink onClick={toggle} to={item.to} end={item.end}>
                        <span className="menu_idx">{String(i + 1).padStart(2, "0")}.</span>
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                  <li className="menu_item">
                    <a
                      href="/assets/Andrew_Jordan_Resume_2026.pdf"
                      onClick={toggle}
                      download
                    >
                      <span className="menu_idx">05.</span>resume
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="menu_footer mono d-flex flex-column flex-md-row justify-content-between align-items-md-center position-absolute w-100 p-3">
            <div className="d-flex">
              <a href={socialprofils.github} target="_blank" rel="noopener noreferrer">github</a>
              <a href={socialprofils.linkedin} target="_blank" rel="noopener noreferrer">linkedin</a>
              <a href={socialprofils.twitter} target="_blank" rel="noopener noreferrer">twitter</a>
            </div>
            <p className="copyright m-0">{"// built with react"}</p>
          </div>
        </div>
    </>
  );
};

export default Headermain;
